import React, { useState, useEffect } from "react";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const ListOfContractor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("List of Contractor"));
  }, []);
  const [contractorList, setContractorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const normalizeData = (data) => {
  return data?.map(item => ({
    ...item,
    Ifexists: item?.Ifexists == 1 ? 0 : 1
  }));
};

  const columns = {
    ClientName: { text: " Name", align: "left", width: "150px", visible: true },
    Vendor: {text: "Vendor Name",align: "left",width: "200px",visible: true},
    Title: { text: "Title", align: "left", visible: true },
    Role: { text: "Role", align: "left", visible: true },
    TotalExp: { text: "Exp.", align: "end", visible: true },
    Cost: { text: "Cost", align: "end", visible: true },
    SubConCur: { text: "Currency", align: "end", visible: true },
    SubConFreq: { text: "Frequency", align: "end", visible: true },
    InvoiceRate: { text: "Billing Rate", align: "end", visible: false },
    Frequency: { text: "Billing Freq.", align: "end", visible: false },
    CurrentLocation: { text: "Current Location", align: "left", width: "150px", visible: true },
    Name: { text: "Client Name", align: "left", visible: true },
    ResCost: { text: "PO Cost", align: "end", visible: true },
    ResCurrency: { text: "PO Currency", align: "left"  },
    ResFrequency: { text: "PO Frequency", align: "left" },
    ResStartDate: { text: "Start Date", align: "center", visible: true },
    ResEndDate: { text: "End Date", align: "center", visible: true }
  };

  useEffect(() => {
    fetchListOfContractors();
  }, []);

  const contractStatus_option = [
    { value: "1", label: "Open" },
    { value: "2", label: "Closed" },
  ];

  const [contratStatus, setContratStatus] = useState([]);
  const [apiStatus, setApiStatus] = useState(undefined);
  const [showCreateEmployee, SetShowCreateEmployee] = useState(false);
  const [createEmployee, setCreateEmployee] = useState();
  const [filterFormData, setFilterData] = useState([]);

  const fetchListOfContractors = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor?P_Id=${contratStatus ? contratStatus : 1}`
      );
      setApiStatus
        (response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;
        setContractorList(
          cleanedData?.map(item => ({
            ...item,
            Ifexists: item?.Ifexists == 1 ? 0 : 1
          }))
        );
        setContractorList(normalizeData(cleanedData));
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleEdit = (id) => {
    // navigate(`/contractors/edit/${id.ID}`);
    const url = `/contractors/edit/${id.ID}`;
    window.open(url, '_blank'); // Opens in new tab
  };

  const jobOptions = [
    { value: "1", label: "open" },
    { value: "2", label: "hold" },
    { value: "3", label: "closed" },
  ];
  const formDatas = [
    {
      name: "Contract Status",
      type: "Select",
      options: [...contractStatus_option],
    },
  ];

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor?P_Id=${filterFormData.find((o) => o.label === "Contract Status")
          ? filterFormData.find((o) => o.label === "Contract Status").value
          : 0
        }`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;
        setContractorList(cleanedData);
        setContractorList(normalizeData(cleanedData));
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };


  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const handleOpen = (id) => {
    setCreateEmployee(id);
    // navigate(`/add-contractor`);
    SetShowCreateEmployee(true);
  };
  const handleClose = () => {
    // navigate(`/add-contractor`);
    SetShowCreateEmployee(false);
  };

  const handleCreateEmployee = async (e) => {
    e.preventDefault();

    setLoading(true); // Assuming setLoading is defined

    try {
      // First API call to create an employee
      let response = await PostServiceCaller(
        `${API_URL}email-rom`,
        {
          Name: createEmployee?.ClientName,
          NSS_ID: "",
          StartDate: createEmployee?.ResStartDate,
          Email: createEmployee?.Email?.Email,
          Mobile: createEmployee?.Phone,
          CurrentLocation: createEmployee?.CurrentLocation,
          Designation: createEmployee?.Role,
          SubContractorID: createEmployee?.ID,
        },
        "post"
      );

      if (response.status === 200) {
        toast.success("Employee Created Successfully");
        SetShowCreateEmployee(false);

        // Optional: Clear form data or redirect after a delay
        // setFormData1(initialFormData);
        // setTimeout(() => {
        //   window.location.href = "/clientmaster";
        // }, 2000);

        // Proceed to the second API call to convert contractor to employee
        response = await PostServiceCaller(
          `${API_URL}contractor-to-employee`,
          {
            contractor_id: createEmployee?.ID,
          },
          "post"
        );

        if (response.status === 201) {
          toast.success("Contractor converted to Employee Successfully");
          fetchListOfContractors();
        } else {
          console.error(
            "Failed to convert contractor. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } else {
        // console.error(
        //   "Failed to submit data. Server responded with status:",
        //   response.status
        // );
        console.error("Response data:", response.data.error);

        toast.error(response.data.error, {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while submitting data:", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error, {
          position: "top-right",
        });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };



  const handleReset = () => {
    fetchListOfContractors()
    setFilterData([])
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={contractorList}
              handleReset={handleReset}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              showIcon1={true}
              showIcon2={false}
              showIcon3={false}
              showIcon4={true}
              showIcon5={false}
              formDatas={formDatas}
              isSorting={true}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              isActionRequired={true}
              isFilterRequired={true}
              isCheckBoxRequired={false}
              handleIcon1={handleEdit}
              handleIcon4={handleOpen}
              handleChange={handleChange}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square  icons"></i>,
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-person-plus icons"></i>,
                Icon4Flag: "Ifexists",
                Icon4Text: "Create Employee",
              }}
            />
          </div>
        </div>


        {/* New Model Design  */}
        {showCreateEmployee && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: '1px solid #f0f0f0',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px 8px 0 0'
                }}>
                  <p
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}
                  >
                    <i className="bi bi-exclamation-triangle-fill me-2 text-warning"></i>
                    Confirm
                  </p>
                  <span className="me-2">
                    <i className="bi bi-x-lg" onClick={handleClose}></i>
                  </span>
                </div>

                <div
                  className="modal-body"
                  style={{ maxHeight: "60vh", overflowY: "auto" }}
                >
                  <p className="mb-0">
                    Are you sure you want to create an employee for this Sub
                    Contractor?
                  </p>
                </div>

                <div className="modal-footer d-flex justify-content-end">
                  <button className="cancel-btn-sm me-1" onClick={handleClose}>
                    No
                  </button>
                  <button
                    disabled={loading}
                    type="button"
                    className="custom-btn-sm"
                    onClick={handleCreateEmployee}
                  >
                    {loading ? <FaSpinner className="sm-spinner" /> : "Yes"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ListOfContractor;
